import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, Observable, Subject, takeUntil } from 'rxjs';
import { ICommunityFeed } from 'src/app/core/domain/community-feed';
import { IProfileDetails } from 'src/app/core/domain/profile.model';
import { CommunityFeedService } from 'src/app/core/service/community-feed.service';
import { getProfileData } from 'src/app/core/state/profile';
import { FeedFormPollSelectModalComponent } from '../../community-feed-form/feed-form-poll-select-modal/feed-form-poll-select-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

export enum PollTimeLine {
  ONE_DAY = 'one_day',
  THREE_DAY = 'three_day',
  ONE_WEEK = 'one_week',
  TWO_WEEK = 'two_week',
}

@Component({
  selector: 'app-poll-post',
  templateUrl: './poll-post.component.html',
  styleUrls: ['./poll-post.component.scss']
})
export class PollPostComponent implements OnInit {

  public getProfileData$: Observable<IProfileDetails>;
  profileData: IProfileDetails;
  private destroyed$: Subject<void> = new Subject();

  @Input() pollData!: ICommunityFeed;
  @Input() onCreationTime: boolean = false;
  @Output() pollEdit = new EventEmitter<string>();
  @Output() pollDeleted = new EventEmitter<string>();

  selectedOption: any = null;
  hasVoted = false;
  remainingTimeLabel: string = '';
  isPollListing: any;

  constructor(private feedService: CommunityFeedService, private store: Store, private modalService: NgbModal,) { }

  ngOnInit(): void {
    this.isPollListing = this.pollData.poll;
    this.getProfileData$ = this.store.pipe(select(getProfileData));
    this.getProfileData$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
      // getProfileData's initial/default state is null before the profile
      // loads - reading res.id unconditionally threw on that first emission
      // (SC-SAAS-FRONTEND-1A). Same guard already used elsewhere for this
      // selector (e.g. conversation-details.component.ts).
      if (res) {
        this.getAlreadyVoted(res.id);
      }
    })


    this.calculateVotePercentages();
    const createdAt = this.isPollListing?.pollCreatedAt ? new Date(this.isPollListing.pollCreatedAt) : new Date();
    this.updateRemainingTime(createdAt, this.isPollListing?.timeLine);
    setInterval(() => {
      this.updateRemainingTime(createdAt, this.isPollListing?.timeLine);
    }, 60 * 1000);

  }

  getAlreadyVoted(loginUserId) {
    console.log(loginUserId, loginUserId)
    if (!this.isPollListing?.options) return;

    for (const option of this.isPollListing.options) {
      const hasUserVoted = option.votes?.some((vote: any) => vote.userId == loginUserId);
      if (hasUserVoted) {
        this.hasVoted = true;
        this.selectedOption = option;
        break;
      }
    }
  }

  calculateVotePercentages(): void {
    if (!this.isPollListing?.options) return;

    const totalVotes = this.isPollListing.totalVotes || 0;

    this.isPollListing.options = this.isPollListing.options.map((option: any) => {
      const optionVotes = option.voteCount || (option.votes ? option.votes.length : 0);
      const percentage = totalVotes > 0 ? Math.round((optionVotes / totalVotes) * 100) : 0;
      return { ...option, votePercentage: percentage };
    });
  }

  onVote(option: any): void {
    if (this.hasVoted) return;

    this.selectedOption = option;
    this.hasVoted = true;

    const postData = {
      pollId: this.isPollListing.id,
      optionId: option.id
    };

    this.feedService.isVoteForPoll(postData).subscribe({
      next: (res) => {
        option.voteCount = (option.voteCount || 0) + 1;
        this.isPollListing.totalVotes = (this.isPollListing.totalVotes || 0) + 1;

        this.calculateVotePercentages();
      },
      error: (err) => console.error('Vote error:', err)
    });
  }
  getRemainingDays(startDate: Date, timeline: PollTimeLine): string {
    let endDate = new Date(startDate);

    switch (timeline) {
      case PollTimeLine.ONE_DAY: endDate.setDate(endDate.getDate() + 1); break;
      case PollTimeLine.THREE_DAY: endDate.setDate(endDate.getDate() + 3); break;
      case PollTimeLine.ONE_WEEK: endDate.setDate(endDate.getDate() + 7); break;
      case PollTimeLine.TWO_WEEK: endDate.setDate(endDate.getDate() + 14); break;
      default: endDate.setDate(endDate.getDate() + 3); break;
    }
    console.log(endDate, "endDate")
    const diffMs = endDate.getTime() - new Date().getTime();

    if (diffMs <= 0) return 'Poll closed';

    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays > 0) return diffDays === 1 ? '1 day left' : `${diffDays} days left`;
    return 'Less than a day left';

  }

  updateRemainingTime(startDate: Date, timeline: PollTimeLine) {
    this.remainingTimeLabel = this.getRemainingDays(startDate, timeline);
  }


  onEditPoll(poll: any) {
    const modalRef = this.modalService.open(FeedFormPollSelectModalComponent)
    modalRef.componentInstance.modalRef = modalRef;
    modalRef.componentInstance.pollData = poll;
    modalRef.result.then((res) => {
      if (res) {
        this.pollData = res;
        this.isPollListing = this.pollData.poll
        this.pollEdit.emit(res);
      }
    });
  }

  onDeletePoll(poll: any) {
    this.isPollListing = null;
    this.pollDeleted.emit(poll);

  }
}
